var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCommissioning = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.611 0.478L6.559 0.478 6.559 6.431 0.611 6.431z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(0 .75)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .75) translate(7 6.667) translate(27.103 .152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M6.559 3.453c0 1.644-1.33 2.978-2.973 2.978C1.944 6.43.61 5.097.61 3.453.61 1.81 1.944.478 3.586.478c1.642 0 2.973 1.332 2.973 2.975",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M6.584 18.459h14.022v-3.83H6.584v3.83zm-.163 1.893c-.954 0-1.732-.776-1.732-1.73v-4.156c0-.954.778-1.73 1.732-1.73h14.35c.954 0 1.73.776 1.73 1.73v4.156c0 .954-.776 1.73-1.73 1.73H6.42zm-2.598-9.236c-.428 0-.776.348-.776.775v10.052c0 .428.348.777.776.777h19.544c.429 0 .777-.349.777-.777V11.891c0-.427-.348-.775-.777-.775H3.823zm0 13.554c-.428 0-.776.348-.776.776v6.071c0 .428.348.777.776.777h19.544c.429 0 .777-.349.777-.777v-6.07c0-.429-.348-.777-.777-.777H3.823zm0 9.518c-1.472 0-2.67-1.198-2.67-2.67v-6.072c0-.622.222-1.229.625-1.71l.033-.04-.033-.041c-.401-.479-.623-1.083-.625-1.703v-.056l-.057-.006C.471 21.829 0 21.308 0 20.678c0-.628.47-1.148 1.095-1.21l.057-.005v-7.572c0-1.471 1.199-2.668 2.671-2.668h2.843V7.324c0-.528.43-.958.959-.958.529 0 .958.43.958.958v1.899h10.025V7.324c0-.528.43-.958.96-.958.528 0 .958.43.958.958v1.899h2.841c1.473 0 2.672 1.197 2.672 2.668v7.572l.057.006c.625.062 1.097.582 1.097 1.21s-.472 1.149-1.097 1.21l-.057.007v.056c-.002.62-.224 1.224-.626 1.703l-.034.04.034.041c.404.48.626 1.088.626 1.71v6.071c0 1.473-1.199 2.671-2.672 2.671H3.823z",
    transform: "translate(0 .75) translate(7 6.667)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCommissioning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_commissioning.3edd4d1ea385dff05f478ee7a97b85b2.svg";